export default __webpack_public_path__ + "static/roadclosed-907afefcf2dd1ddf72a00381f1e93578.jpg";